export default __webpack_public_path__ + "app/assets/mad-cat-7a531c15.gif";